import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => ( {
	contianer: {
		padding         : "2.5rem",
		backgroundColor : theme.other.darkMode ? theme.other.paletteNew.darkModeInclinedBlack2 : theme.other.paletteNew.secondaryBackgroundGrey,
		textAlign       : "center",
		borderRadius    : "1.5rem",
		width           : "230px",

		[rooterMediaQuery.mobile]: {
			width: "90%"
		}
	},
	imageContainer: {
		position: "relative"
	},
	liveTag: {
		position        : "absolute",
		bottom          : "25%",
		right           : "50%",
		transform       : "translate(50%, 50%)",
		backgroundImage : "linear-gradient(rgb(18, 107, 213), rgb(67, 154, 255))",
		border          : "1.25px solid #fff",
		borderRadius    : "0.5rem",
		padding         : "0.1rem 0.75rem",
		display         : "flex",
		justifyContent  : "center",
		alignItems      : "center"
	},
	liveTagText: {
		color      : "#fff",
		fontSize   : "1rem",
		fontWeight : "500"
	},
	image: {
		height       : "7rem",
		width        : "7rem",
		objectFit    : "contain",
		borderRadius : "100%",
		marginBottom : "1.25rem",
		// ...( props?.fullWidth && { width: "100%" } ),
		...( props?.isLive && { border: `2px solid ${ theme.other.paletteNew.primaryDarkBlue }` } ),
		...( props?.isLive && { padding: "2px" } )
	},
	infoContainer: {
		marginBottom: "2.75rem"

	},
	nameContianer: {
		display        : "flex",
		alignItems     : "center",
		justifyContent : "center",
		marginBottom   : "0.5rem"

	},
	nameLink: {
		maxWidth: "85%"
	},
	name: {
		fontSize        : "1.6rem",
		fontWeight      : "500",
		cursor          : "pointer",
		textOverflow    : "ellipsis",
		WebkitLineClamp : 1,
		overflow        : "hidden",
		display         : "-webkit-box",
		WebkitBoxOrient : "vertical",

		[rooterMediaQuery.tablet]: {
			fontSize: "1.4rem"
		}

	},
	followerCount: {
		fontSize: "1.325rem"
	},
	icon: {
		height     : "1.5rem",
		width      : "1.5rem",
		marginLeft : "0.5rem"
	},
	followButton: {
		...( !theme.other.darkMode && { background: theme.other.paletteNew.secondaryLightGrey } ),

		"&:hover": {
			background: `${ theme.other.paletteNew.primaryLinearGradient } !important`,

			"& p": {
				color: theme.other.paletteNew.secondaryWhite
			}
		}
	},
	unFollowButton: {
		...( !theme.other.darkMode && { background: theme.other.paletteNew.secondaryLightGrey } )
	}

} ), { name: "creatorCard" } );
